import { Injectable } from '@angular/core';

@Injectable()

export class Config {

  private _config: any;

  constructor() {
    this._config = {
      'API_SERVER_URL': '/api/rs'
    };
  }

  get(key: any): any {
    return this._config[key];
  }

}
